// extracted by mini-css-extract-plugin
module.exports = {"footerLinks":"FooterColumnGroup_footerLinks__Yw2BG","open":"FooterColumnGroup_open__itWJ0"};